// client/src/services/userService.js

import { getApiConfig } from '../config/markets.js';

const API_URL = getApiConfig().apiUrl;

/**
 * Actualiza el perfil del usuario (name, email, password).
 * - En el body puedes enviar uno o varios campos:
 *    { name, email, password }
 */
export async function updateMyProfile({ name, email, password, currentPassword }) {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No hay token de autenticación');
    }

    const body = {};
    if (typeof name === 'string') body.name = name;
    if (typeof email === 'string') body.email = email;
    if (typeof password === 'string') body.password = password;
    if (typeof currentPassword === 'string') body.currentPassword = currentPassword;

    const res = await fetch(`${API_URL}/users/me`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(body)
    });
  
    if (!res.ok) {
      let errMsg = 'Error al actualizar perfil';
      try {
        const data = await res.json();
        errMsg = data.error || data.message || errMsg;
      } catch {}
      throw new Error(errMsg);
    }
  
    return await res.json(); // { user: { id, name, email, … } }
  }

/**
 * Obtiene la lista de todos los usuarios
 * @returns {Promise<Array>} Lista de usuarios
 */
export async function getAllUsers() {
  const token = localStorage.getItem('token');
  if (!token) {
    throw new Error('No hay token de autenticación');
  }

  const res = await fetch(`${API_URL}/users`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }
  });

  if (!res.ok) {
    let errMsg = 'Error al obtener usuarios';
    try {
      const data = await res.json();
      errMsg = data.error || data.message || errMsg;
    } catch {}
    throw new Error(errMsg);
  }

  return await res.json(); // { users: [...] }
}

